import gql from 'graphql-tag'
import { TableContext } from 'labguard-cdk'
import { channelTileFields } from 'src/components/common/ChannelTile'
import { useGroupId, usePollingQuery } from 'src/hooks'
import useStatusFilter from './useStatusFilter'

const query = gql`
  ${channelTileFields}
  query groupFilteredChannels($groupId: ID!, $status: [ChannelStatus]) {
    group(id: $groupId) {
      id
      name
      channelCount
      channels(status: $status) {
        id
        ...ChannelTileFields
      }
    }
  }
`

export default function useGroupFilteredChannelsData() {
  const [status] = useStatusFilter()

  // get channels filtered by status
  const { refetch, loading, data: { group: { channels = [], channelCount = 0 } = {} } = {} } = usePollingQuery(query, {
    variables: { groupId: useGroupId(), status },
  })

  // filter channels by name
  const { useData } = TableContext.use()
  const data = useData(channels)

  return { channels: data, channelCount, loading, refetch }
}
